import {AnyLinkType} from 'shared/pretty-easy-navigation/models';

/***
Informations légales,Link,/informations-legales
Plan du site,Link,/page/site-map
*/

export const LearnerMenu: AnyLinkType[] = [
    {
        type: 'link',
        label: 'navigation.assignment_learner',
        link: '/followed/tab/list',
    },
    {
        type: 'link',
        label: 'navigation.home',
        link: '/home',
    },
    {
        type: 'link',
        label: 'navigation.own_graph',
        link: '/graph-inclusive/single/own-progress',
    },
    {
        type: 'accordionLinkGroup',
        label: 'navigation.corpus_group',
        links: [
            {
                type: 'link',
                label: 'navigation.corpus_global',
                link: '/corpus/11057',
            },
            {
                type: 'link',
                label: 'navigation.corpus_user',
                link: '{{USER_CORPUS_LINK}}',
            },
        ],
    },
    {
        type: 'accordionLinkGroup',
        label: 'navigation.tools',
        links: [
            {
                type: 'link',
                label: 'navigation.notepad',
                link: '/notepad/list',
            },
            {
                type: 'link',
                label: 'navigation.mindmap',
                link: '/mindmap/list',
            },
            {
                type: 'link',
                label: 'navigation.bd_tool',
                link: '/bd-tool/list',
            },
        ],
    },
    {
        type: 'link',
        label: 'navigation.legal_notice',
        link: '/informations-legales',
    },
    {
        type: 'link',
        label: 'navigation.site_map',
        link: '{{SITE_MAP_LINK}}',
    },
];
